var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewHalficon = function SvgPreviewHalficon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.6 3.5H3.4a12.288 12.288 0 0 0-.883.017l-.002.02c-.014.175-.015.418-.015.863v7.2a12.285 12.285 0 0 0 .017.883 12.265 12.265 0 0 0 .883.017h9.2a12.262 12.262 0 0 0 .883-.017l.002-.02c.014-.175.015-.418.015-.863V4.4a12.265 12.265 0 0 0-.017-.883A12.285 12.285 0 0 0 12.6 3.5ZM1.163 2.819C1 3.139 1 3.559 1 4.4v7.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.581.164h9.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .655-.655c.164-.32.164-.74.164-1.581V4.4c0-.84 0-1.26-.164-1.581a1.5 1.5 0 0 0-.655-.656C13.861 2 13.441 2 12.6 2H3.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 4.5h3.2c.28 0 .42 0 .527.055a.5.5 0 0 1 .218.218c.055.107.055.247.055.527v5.4c0 .28 0 .42-.055.527a.5.5 0 0 1-.218.219c-.107.054-.247.054-.527.054H8.5v-7Z",
    opacity: 0.6
  })));
};
export default SvgPreviewHalficon;